export default __webpack_public_path__ + "static/media/20210819182519.afabb14e.png";